import { SearchFilterComponent } from './search-filter/search-filter.component';

export const Components = [
	SearchFilterComponent,
];
